import { memo } from 'react';
import styles from './AdvtSms.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import { AnimatePresence, motion } from 'motion/react';

import logo from '../../assets/images/logo.png';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const AdvtSms = memo(() => {
  const {
    title,
    qrCode1,
    qrCode2,
    paddingQR,
    sizeQR,
    titleFontSize,
    phoneNumberFontSize,
    phoneNumber,
  } = useGetParams();

  const formattedPhoneNumber = formatPhoneNumber(phoneNumber);

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />

      {title && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8 }}
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {title}
        </motion.div>
      )}

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        className={styles.subtitle}
      >
        Присылайте sms
      </motion.div>

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.8, delay: 1 }}
        className={styles.phoneNumber}
        style={{ fontSize: `${phoneNumberFontSize}rem` }}
      >
        {formattedPhoneNumber}
      </motion.div>
    </div>
  );
});

export default AdvtSms;
